import * as React from 'react';
import {
  List, Datagrid, Edit, Create, Show, SimpleShowLayout,
  TextField, BooleanField, DateField, ImageField,
  SimpleForm, TextInput, NumberInput, BooleanInput,
  TopToolbar, Button, EditButton, ShowButton, required
} from 'react-admin';
import { useRedirect } from 'react-admin';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { UpLoadFile, FirstImageField, CurrentImage } from '../custom/UpLoadFile';

const useTxtData = {
  page: { tableName: '积分商品' },
  table: {
    id: 'ID',
    Title: '标题',
    Pic: '图片',
    NeedJifen: '所需积分',
    OrderNumb: '排序',
    status: '状态',
    AtTime: '时间'
  }
};

const RowAction = (props) => {
  return (
    <div style={{ textAlign: 'right' }}>
      <EditButton {...props} /><br />
      {/* <ShowButton {...props} /> */}
    </div>
  );
};

export const LFJiFenProductList = (props) => (
  <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'id', order: 'DESC' }} exporter={false}>
    <Datagrid>
      <TextField label={useTxtData.table.id} source="id" />
      <FirstImageField label={useTxtData.table.Pic} source="Pic" picResize />
      <TextField label={useTxtData.table.Title} source="Title" />
      <TextField label={useTxtData.table.NeedJifen} source="NeedJifen" />
      <TextField label={useTxtData.table.OrderNumb} source="OrderNumb" />
      <BooleanField label={useTxtData.table.status} source="status" />
      <DateField label={useTxtData.table.AtTime} source="AtTime" showTime />
      <RowAction />
    </Datagrid>
  </List>
);

export const LFJiFenProductShow = (props) => {
  const redirect = useRedirect();
  return (
    <Show title={'查看' + useTxtData.page.tableName} {...props} actions={
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect('/Admin/LFJiFenProduct')} variant="text">
          <ArrowBack />
        </Button>
      </TopToolbar>
    }>
      <SimpleShowLayout>
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.Title} source="Title" />
        <ImageField label={useTxtData.table.Pic} source="Pic" />
        <TextField label={useTxtData.table.NeedJifen} source="NeedJifen" />
        <TextField label={useTxtData.table.OrderNumb} source="OrderNumb" />
        <BooleanField label={useTxtData.table.status} source="status" />
        <DateField label={useTxtData.table.AtTime} source="AtTime" />
      </SimpleShowLayout>
    </Show>
  );
};

export const LFJiFenProductEdit = (props) => (
  <Edit title={'编辑' + useTxtData.page.tableName} {...props} mutationMode={'pessimistic'}>
    <SimpleForm>
      <TextInput label={useTxtData.table.Title} source="Title" validate={required()} />
      <CurrentImage label={useTxtData.table.Pic} source="Pic" />
      <UpLoadFile label={useTxtData.table.Pic} source="Pic" />
      <NumberInput label={useTxtData.table.NeedJifen} source="NeedJifen" />
      <NumberInput label={useTxtData.table.OrderNumb} source="OrderNumb" />
      <BooleanInput label={useTxtData.table.status} source="status" />
    </SimpleForm>
  </Edit>
);

export const LFJiFenProductCreate = (props) => (
  <Create title={'新增' + useTxtData.page.tableName} {...props} mutationMode={'pessimistic'}>
    <SimpleForm>
      <TextInput label={useTxtData.table.Title} source="Title" validate={required()} />
      <UpLoadFile label={useTxtData.table.Pic} source="Pic" />
      <NumberInput label={useTxtData.table.NeedJifen} source="NeedJifen" defaultValue={0} />
      <NumberInput label={useTxtData.table.OrderNumb} source="OrderNumb" defaultValue={0} />
      <BooleanInput label={useTxtData.table.status} source="status" defaultValue={true} />
    </SimpleForm>
  </Create>
);